import classNames from 'classnames';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList, {
  CtaLinkListProps,
} from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import AddOnProductsMatrix from './add-on-products-matrix/add-on-products-matrix';
import styles from './add-on-products.module.scss';

export interface AddOnProductsProps extends ModuleWrapperProps {
  /** The class name to apply */
  className?: string;
  /** An array of links to show */
  ctaLinks?: CtaLinkListProps['items'];
  /** The text to show as a headline */
  headline?: string;
  /** The data to show in the table */
  matrix: {
    headlines: string[];
    items: string[][];
  };
  /** Indicates whether to show the price per person labels */
  showPricePerPerson?: boolean;
  /** The text to show as a sub headline */
  text?: string;
}

const AddOnProducts = ({
  className,
  ctaLinks = [],
  headline,
  matrix,
  showPricePerPerson = false,
  text,
  ...rest
}: AddOnProductsProps) => {
  return (
    <ModuleWrapper
      {...rest}
      className={classNames(styles.component, className)}
    >
      <Container>
        <Row className={styles.row}>
          <Column className={styles.contentColumn} width={{ laptop: 4 }}>
            <div className={styles.content}>
              {headline && (
                <Typography
                  className={styles.headline}
                  tagStyle="displayMedium"
                >
                  {headline}
                </Typography>
              )}

              {text && <RichText text={text} />}
            </div>

            {ctaLinks.length > 0 && (
              <div>
                <CtaLinkList items={ctaLinks} />
              </div>
            )}
          </Column>

          <Column offset={{ laptop: 1 }} width={{ laptop: 7 }}>
            <AddOnProductsMatrix
              {...matrix}
              showPricePerPerson={showPricePerPerson}
            />
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

AddOnProducts.displayName = 'AddOnProducts';

export default AddOnProducts;
